<template>
  <div
    :class="DS_EMOJI_PICKER_CLASSES.Search"
    data-cy="ds-emoji-picker__search"
  >
    <DSBaseInput
      ref="searchRef"
      v-model="modelValue"
      type="search"
      data-cy-suffix="emoji-picker-search"
      prefix="search"
      :aria-label="SEARCH_PLACEHOLDER"
      :placeholder="SEARCH_PLACEHOLDER"
      :readonly="false"
      :clearable="false"
      @keydown.enter.prevent
      @select.stop
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, useTemplateRef } from "vue";
import { DS_EMOJI_PICKER_CLASSES } from "@/src/design_system/button_and_controls/emoji_picker/constants/classes";
import DSBaseInput from "@/src/design_system/form_elements/base_input/components/DSBaseInput.vue";

const modelValue = defineModel<string>({ required: true });

const searchRef = useTemplateRef<InstanceType<typeof DSBaseInput>>("searchRef");
const SEARCH_PLACEHOLDER = window.I18n.designSystem.emojiPicker.searchPlaceholder;

onMounted(() => {
  requestAnimationFrame(() => searchRef.value?.focus());
});
</script>
